// extracted by mini-css-extract-plugin
module.exports = {"mentionSuggestions":"MentionTheme_mentionSuggestions__Q8c0P","mentionEntry":"MentionTheme_mentionEntry__1ipKo","mentionEntryAvatar":"MentionTheme_mentionEntryAvatar__2EKdC"};